<template>
    <div class="stepper">

        <transition name="slide-fade">
            <div class="text-center" v-if="retirement.thirdStepActive === 1">
                <label class="label">คุณมีกองทุนสำรองเลี้ยงชีพ (PROVIDENT FUND : PVD)</label>
                <div>
                    <md-radio v-model="form.havePVD" value='Y'>มี</md-radio>
                    <md-radio v-model=" form.havePVD" value='N'>ไม่มี</md-radio>
                </div>

                <div class="row justify-content-center">
                    <div class="col-auto">
                        <div class="button-accent" @click="nextStep(2)">ย้อนกลับ</div>
                    </div>
                    <div class="col-auto">
                        <div class="button-yellow" @click="nextSubStep(2 , 'next')">ถัดไป</div>
                    </div>
                </div>
            </div>
        </transition>


        <transition name="slide-fade">
            <div v-if="retirement.thirdStepActive === 2">


                <div class="row justify-content-center">
                    <div class="col-auto">

                        <label class="label">
                            <img class="img-fluid icon" src="../assets/images/chart.png">
                            แผนการลงทุนในกองทุนสำรองเลี้ยงชีพ (PVD) ที่สมาชิกเลือก
                        </label>

                        <div class="pvd-plan mb-5 pl-5">
                            <div>
                                <md-radio v-model="form.planPVD" value='1'>ไม่ทราบแผนการลงทุน</md-radio>

                            </div>

                            <div>
                                <md-radio v-model="form.planPVD" value='2'>ลงทุนตลาดเงินและตราสารหนี้ระยะสั้น 100%
                                </md-radio>
                            </div>


                            <div>
                                <md-radio v-model="form.planPVD" value='3'>ลงทุนตราสารหนี้ 100%</md-radio>
                            </div>


                            <div>
                                <md-radio v-model="form.planPVD" value='4'>ลงทุนตราสารทุน 100%</md-radio>
                            </div>


                            <div>
                                <div class="row">
                                    <div class="col-12 col-sm-auto form-group">
                                        <md-radio v-model="form.planPVD" value='5'>ลงทุนแบบผสม</md-radio>
                                    </div>
                                </div>


                                <div class="padding-stepper">
                                    <div class="row align-items-center">
                                        <div class="col-12 col-sm-auto  form-group col-stepper">
                                            ตลาดเงินและตราสารหนี้ระยะสั้น (%)
                                        </div>

                                        <div class="col-12 col-sm-auto  form-group input-group-lg">
                                            <money v-model="form.planMoneyFund" v-bind="percent"
                                                   class="form-control input-money"
                                                   placeholder="โปรดระบุ"
                                                   :disabled="form.planPVD !== '5'">
                                            </money>
                                            <error-message :msg="errorMessage.planMoneyFund"></error-message>
                                        </div>
                                    </div>


                                    <div class="row align-items-center">
                                        <div class="col-12 col-sm-auto  form-group col-stepper">
                                            ตราสารหนี้ (%)
                                        </div>

                                        <div class="col-12 col-sm-auto  form-group input-group-lg">
                                            <money v-model="form.planBondFund" v-bind="percent"
                                                   class="form-control input-money"
                                                   placeholder="โปรดระบุ"
                                                   :disabled="form.planPVD !== '5'">
                                            </money>
                                            <error-message :msg="errorMessage.planBondFund"></error-message>
                                        </div>
                                    </div>


                                    <div class="row align-items-center">
                                        <div class="col-12 col-sm-auto  form-group col-stepper">
                                            ตราสารทุน (%)
                                        </div>

                                        <div class="col-12 col-sm-auto  form-group input-group-lg">
                                            <money v-model="form.planEquityFund" v-bind="percent"
                                                   class="form-control input-money"
                                                   placeholder="โปรดระบุ"
                                                   :disabled="form.planPVD !== '5'">
                                            </money>
                                            <error-message :msg="errorMessage.planEquityFund"></error-message>
                                        </div>
                                    </div>
                                    <error-message :msg="errorMessage.totalFund"></error-message>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-auto">
                        <div class="button-accent" @click="nextSubStep(1)">ย้อนกลับ</div>
                    </div>
                    <div class="col-auto">
                        <div class="button-yellow" @click="nextSubStep(3, 'next')">ถัดไป</div>
                    </div>
                </div>


            </div>
        </transition>


        <transition name="slide-fade">
            <div v-if="retirement.thirdStepActive === 3">

                <div class="mb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-sm-5 label ">
                            <div class="row align-items-center form-group">
                                <div class="col-auto">
                                    <img class="img-fluid icon" src="../assets/images/taxe.png">
                                </div>
                                <div class="col label no-padding">
                                    เงินกองทุนสำรองเลี้ยงชีพ (PVD) ทั้งหมดในปัจจุบันของสมาชิก (บาท)
                                    <div class="txt-desc">* รวมเงินที่สมาชิกสะสมและนายจ้างสมทบ</div>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm form-group input-group-lg">
                            <money v-bind="money" v-model="form.pvdAmount"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>

                            <error-message :msg="errorMessage.pvdAmount"></error-message>
                        </div>
                    </div>
                </div>


                <div class="mb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-sm-5 label">
                            <div class="row align-items-center form-group">
                                <div class="col-auto">
                                    <img class="img-fluid icon" src="../assets/images/chart1.png">
                                </div>
                                <div class="col label no-padding">
                                    อัตราร้อยละที่สมาชิกสะสม (%)
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm form-group input-group-lg">
                            <money v-bind="money" v-model="form.employee"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>
                            <error-message :msg="errorMessage.employee"></error-message>
                        </div>
                    </div>
                </div>


                <div class="mb-3">
                    <div class="row align-items-center">
                        <div class="col-12 col-sm-5 label">
                            <div class="row align-items-center form-group">
                                <div class="col-auto">
                                    <img class="img-fluid icon" src="../assets/images/bank.png">
                                </div>
                                <div class="col label no-padding">
                                    อัตราร้อยละที่นายจ้างสมทบ (%)
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-sm form-group input-group-lg">
                            <money v-bind="money" v-model="form.employer"
                                   class="form-control"
                                   placeholder="โปรดระบุ"></money>

                            <error-message :msg="errorMessage.employer"></error-message>
                        </div>
                    </div>
                </div>


                <div class="row justify-content-center">
                    <div class="col-auto">
                        <div class="button-accent" @click="nextSubStep(2)">ย้อนกลับ</div>
                    </div>
                    <div class="col-auto">
                        <div class="button-yellow" @click="nextSubStep(4,'next')">ถัดไป</div>
                    </div>
                </div>


            </div>
        </transition>


        <transition name="slide-fade">
            <div v-if="retirement.thirdStepActive === 4">

                <div class="row justify-content-center">
                    <div class="col-auto">
                        <div class="">
                            <label class="label form-group">คุณมีกองทุนประกันสังคม (SOCIAL SECURITY FUND)</label>
                            <div>
                                <div class="row">
                                    <div class="col-12 col-sm-auto form-group ">
                                        <md-radio v-model="form.haveSSO" value='Y'>มี</md-radio>
                                    </div>
                                    <div class="col-12 col-sm-auto form-group input-group-lg">
                                        <input class="form-control min-width-haveSSO" type="number"
                                               placeholder="ระบุจำนวนปีที่เป็นสมาชิก"
                                               :disabled="form.haveSSO !== 'Y'" v-model="form.startSSO">
                                        <error-message :msg="errorMessage.startSSO"></error-message>
                                    </div>
                                </div>


                                <div>
                                    <md-radio v-model=" form.haveSSO" value='N'>ไม่มี</md-radio>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="row justify-content-center">
                    <div class="col-auto">
                        <div class="button-accent" @click="nextSubStep(1)">ย้อนกลับ</div>
                    </div>
                    <div class="col-auto">
                        <div class="button-yellow" @click="nextStep(4,'next')">ถัดไป</div>
                    </div>
                </div>


            </div>
        </transition>


        <dialog-normal :data="dataDialogNormal" :show="showDialogNormal" :dialog="dialog"
                       @close="close"></dialog-normal>


    </div>
</template>

<script>

    import store from '../store';
    import {mapState} from 'vuex';
    import {SET_ACTIVE, SET_SUB_ACTIVE, SET_STEPPER_DATA} from '../store/actions.type'
    import * as validate from 'validate.js'
    import DialogNormal from "./dialogNormal";
    import {retirementService} from "../services/retirement";
    import {authService} from "../services/auth";
    import ErrorMessage from "./errorMessage";

    export default {
        name: 'StepperThird',
        components: {ErrorMessage, DialogNormal},
        computed: mapState({
            retirement: state => state.retirement,
            form: state => state.retirement.data.third
        }),
        data: () => ({
            errorMessage: {},
            dialog: {
                header: null,
                message: null,
            },
            showDialogNormal: false,
            dataDialogNormal: {},

            money: {
                thousands: ',',
                precision: 0,
                masked: false
            },
            percent: {
                precision: 2,
                masked: false
            }
        }),
        methods: {
            nextSubStep(nextStep, direction) {

                if (direction === 'next') {
                    let errorMessage = this.validateForm(nextStep, this.form);

                    if (errorMessage.havePVD || errorMessage.retPVD) {
                        let message = null;
                        if (errorMessage.havePVD) {
                            message = 'กองทุนสำรองเลี้ยงชีพ';
                        } else if (errorMessage.retPVD) {
                            message = 'แผนกองทุนสำรองเลี้ยงชีพ';
                        } else if (errorMessage.haveSSO) {
                            message = 'กองทุนประกันสังคม';
                        }

                        this.showDialogNormal = true;
                        this.dialog.message =
                            `<div class="text-center "><div class="md-display-1 mb-2 txt-navy"> กรุณาเลือก </div>
               <div class="md-title mb-3 txt-navy">${message}</div></div>
              `

                        return;
                    } else if (errorMessage) {
                        this.errorMessage = errorMessage;
                        return;
                    }
                }

                this.errorMessage = {};

                // set step
                if (nextStep === 2) {
                    if (this.form.havePVD === 'Y') {
                        nextStep = 2
                    } else if (this.form.havePVD === 'N') {
                        nextStep = 4
                    }
                }

                store.dispatch(SET_SUB_ACTIVE, {key: 'thirdStepActive', step: nextStep});
            },

            async nextStep(step, direction) {

                if (direction === 'next') {
                    let errorMessage = this.validateForm(5, this.form);
                    if (errorMessage.haveSSO) {

                        let message = null;
                        if (errorMessage.haveSSO) {
                            message = 'กองทุนประกันสังคม';
                        }

                        this.showDialogNormal = true;
                        this.dialog.message =
                            `<div class="text-center "><div class="md-display-1 mb-2 txt-navy"> กรุณาเลือก </div>
               <div class="md-title mb-3 txt-navy">${message}</div></div>
              `
                        return;
                    } else if (errorMessage.startSSO) {
                        this.errorMessage = errorMessage;
                        return;
                    }


                    let data = store.state.retirement.data;
                    let resultObj = {
                        // step 1
                        gender: data.first.gender,
                        currentAge: data.first.currentAge,
                        retiredAge: data.first.retiredAge,
                        spendingPerMonth: data.first.spendingPerMonth,
                        spendingBigTourist: data.first.retirementPlan.indexOf('travel') !== -1 ? data.first.spendingBigTourist : 0,
                        spendingBigCar: data.first.retirementPlan.indexOf('buyCar') !== -1 ? data.first.spendingBigCar : 0,
                        spendingBigDebt: data.first.retirementPlan.indexOf('repayDebt') !== -1 ? data.first.spendingBigDebt : 0,
                        spendingBigEtc: data.first.retirementPlan.indexOf('ect') !== -1 ? data.first.spendingBigEtc : 0,
                        spendingBigNurse: data.first.retirementPlan.indexOf('nurse') !== -1 ? data.first.spendingBigNurse : 0,
                        // step 2
                        salary: data.second.salary,
                        savingPerMonth: data.second.savingPerMonth,
                        asset1: data.second.asset1 ? data.second.asset1 : 0,
                        asset2: data.second.asset2 ? data.second.asset2 : 0,
                        asset3: data.second.asset3 ? data.second.asset3 : 0,
                        asset4: data.second.asset4 ? data.second.asset4 : 0,
                        asset5: data.second.asset5 ? data.second.asset5 : 0,
                        asset6: data.second.asset6 ? data.second.asset6 : 0,
                        asset7: data.second.asset7 ? data.second.asset7 : 0,

                        // step 3
                        havePVD: data.third.havePVD,
                        planPVD: data.third.planPVD,
                        planMoneyFund: data.third.planMoneyFund,
                        planBondFund: data.third.planBondFund,
                        planEquityFund: data.third.planEquityFund,

                        pvdAmount: data.third.pvdAmount,
                        employee: data.third.employee,
                        employer: data.third.employer,
                        haveSSO: data.third.haveSSO,
                        startSSO: data.third.startSSO,
                    };


                    if (resultObj.havePVD !== 'Y') {
                        resultObj.pvdAmount = null;
                        resultObj.employee = null;
                        resultObj.employer = null;
                        resultObj.retPVD = null;
                    }


                    if (resultObj.haveSSO !== 'Y') {
                        resultObj.startSSO = null;
                    }

                    // set params
                    store.dispatch(SET_STEPPER_DATA, {key: 'params', data: resultObj});

                    // register if not found pram uid
                    if (!this.$route.query.uid) {
                        await authService.getToken().then(result => {
                            localStorage.setItem('token', result.token)
                        });
                    }


                    let calculatePromise = retirementService.record(resultObj);
                    let suggestionPromise = retirementService.getSuggestion(resultObj);

                    let [calculation, suggestion] = await Promise.all([calculatePromise, suggestionPromise]);

                    store.dispatch(SET_STEPPER_DATA, {key: 'result', data: calculation});
                    store.dispatch(SET_STEPPER_DATA, {key: 'suggestion', data: suggestion.data ? suggestion.data : []});

                    store.dispatch(SET_STEPPER_DATA, {key: 'third', data: this.form});
                }

                store.dispatch(SET_ACTIVE, step);

            }
            ,

            close() {
                this.showDialogNormal = false;
            },

            validateForm(nextStep, data) {
                let errMessageList = null;
                let validateRule = {};

                // set rule
                if (nextStep === 2) {

                    validateRule = {
                        havePVD: {
                            presence: {
                                allowEmpty: false,
                                message: "^โปรดระบุ: กองทุนสำรองเลี้ยงชีพ"
                            },
                        },
                    };

                    // set data to validate
                    errMessageList = validate(
                        {
                            havePVD: data.havePVD,
                        }, validateRule);

                } else if (nextStep === 3) {


                    if (data.planPVD.toString() === '5') {

                        validateRule = {
                            planPVD: {
                                presence: {
                                    allowEmpty: false,
                                    message: "^โปรดระบุ: แผนกองทุนสำรองเลี้ยงชีพ"
                                },
                            },
                            planMoneyFund: {
                                numericality: {
                                    greaterThanOrEqualTo: 0,
                                    lessThanOrEqualTo: 100,
                                    message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%"
                                }
                            },
                            planBondFund: {
                                numericality: {
                                    greaterThanOrEqualTo: 0,
                                    lessThanOrEqualTo: 100,
                                    message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%"
                                }
                            },
                            planEquityFund: {
                                numericality: {
                                    greaterThanOrEqualTo: 0,
                                    lessThanOrEqualTo: 100,
                                    message: "^กรุณากรอกตัวเลขระหว่าง 0 - 100%"
                                }
                            },
                            totalFund: {
                                numericality: {
                                    lessThanOrEqualTo: 100,
                                    greaterThan: 0
                                }
                            },

                        };

                    } else {
                        validateRule = {
                            planPVD: {
                                presence: {
                                    allowEmpty: false,
                                    message: "^โปรดระบุ: แผนกองทุนสำรองเลี้ยงชีพ"
                                },
                            },
                        };
                    }


                    // set data to validate
                    errMessageList = validate(
                        {
                            planPVD: data.planPVD,
                            planMoneyFund: data.planMoneyFund,
                            planBondFund: data.planBondFund,
                            planEquityFund: data.planEquityFund,
                            totalFund: Number(data.planMoneyFund) + Number(data.planBondFund) + Number(data.planEquityFund),

                        }, validateRule);

                } else if (nextStep === 4) {
                    validateRule = {
                        pvdAmount: {
                            presence: {
                                allowEmpty: false,
                                message: "^โปรดระบุ: เงินกองทุนสำรองเลี้ยงชีพ (PVD) ปัจจุบันของสมาชิก"
                            },
                            numericality: {
                                greaterThan: 0,
                                message: "^เงินกองทุนสำรองเลี้ยงชีพ (PVD) ไม่ถูกต้อง"
                            }
                        },
                        employee: {
                            presence: {
                                allowEmpty: false,
                                message: "^โปรดระบุ: อัตราร้อยละที่สมาชิกสะสม",
                            },
                            numericality: {
                                greaterThanOrEqualTo: 2,
                                lessThanOrEqualTo: 15,
                                message: "^กรุณากรอกตัวเลขระหว่าง 2 - 15%"
                            }
                        },
                        employer: {
                            presence: {
                                allowEmpty: false,
                                message: "^โปรดระบุ: อัตราร้อยละที่นายจ้างสมทบ"
                            },
                            numericality: {
                                greaterThanOrEqualTo: 2,
                                lessThanOrEqualTo: 15,
                                message: "^กรุณากรอกตัวเลขระหว่าง 2 - 15%"
                            }
                        },
                    };

                    // set data to validate
                    errMessageList = validate(
                        {
                            pvdAmount: data.pvdAmount,
                            employee: data.employee,
                            employer: data.employer,
                        }, validateRule);

                } else if (nextStep === 5) {

                    if (data.haveSSO === 'Y') {
                        validateRule = {
                            haveSSO: {
                                presence: {
                                    allowEmpty: false,
                                    message: "^โปรดระบุ: กองทุนประกันสังคม"
                                },
                            },
                            startSSO: {
                                presence: {
                                    allowEmpty: false,
                                    message: "^โปรดระบุ: จำนวนปีที่เป็นสมาชิก"
                                },
                                numericality: {
                                    greaterThan: 0,
                                    lessThan: 100,
                                    message: "^จำนวนปีที่เป็นสมาชิก ไม่ถูกต้อง"
                                }
                            },
                        };

                    } else {

                        validateRule = {
                            haveSSO: {
                                presence: {
                                    allowEmpty: false,
                                    message: "^โปรดระบุ: กองทุนประกันสังคม"
                                },
                            },
                        };
                    }


                    // set data to validate
                    errMessageList = validate(
                        {
                            haveSSO: data.haveSSO,
                            startSSO: data.startSSO
                        }, validateRule);
                }


                if (errMessageList) {
                    const error = {};
                    for (const [key, value] of Object.entries(errMessageList)) {

                        let message = value[0];

                        // custom message
                        if (message.includes("Total fund must be less than or equal to")) {
                            message = 'อัตราการลงทุนผสมต้องไม่เกิน 100%';
                        } else if (message.includes("Total fund must be greater than")) {
                            message = 'อัตราการลงทุนผสมต้องมากกว่า 0%';
                        }

                        error[key] = message;
                    }
                    return error;
                } else {
                    return false;
                }

            }
        },
        watch: {
            'form.planMoneyFund': {
                handler() {
                    let total = Number(this.form.planMoneyFund) + Number(this.form.planBondFund);
                    if (total < 100) {
                        this.form.planEquityFund = 100 - total;
                    }
                },
                deep: true
            },

            'form.planBondFund': {
                handler() {
                    let total = Number(this.form.planMoneyFund) + Number(this.form.planBondFund);
                    if (total < 100) {
                        this.form.planEquityFund = 100 - total;
                    }
                },
                deep: true
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/css/colors";

    ::-webkit-input-placeholder {
        font-size: 80%;
        text-align: center;
    }

    :-moz-placeholder { /* Firefox 18- */
        font-size: 80%;
        text-align: center;
    }

    ::-moz-placeholder { /* Firefox 19+ */
        font-size: 80%;
        text-align: center;
    }

    :-ms-input-placeholder {
        font-size: 80%;
        text-align: center;
    }

    .pl-5 {
        padding-left: 80px;
    }
    .padding-stepper{
     padding-left: 35px;
    }
    .col-stepper{
        min-width: 165px;
    }
    .input-money{
        max-width: 250px;
    }
    .min-width-haveSSO{
        min-width: 250px;
    }
</style>
